import type { FieldValues } from 'react-hook-form';
import type { Location } from 'react-router';

export const createRedirectPath = (location: Pick<Location, 'pathname' | 'search' | 'hash'>) =>
  `${location.pathname}${location.search}${location.hash}`;

type CreateAudienceNavigationStateParam = {
  formValues: FieldValues;
  location: Location;
  accountId;
};
export const createAudienceNavigationState = ({
  formValues,
  location,
  accountId,
}: CreateAudienceNavigationStateParam) => {
  const formDataKey: string = location.pathname.startsWith('/inventory/packages') ? 'package' : 'deal';

  return {
    accountId,
    [formDataKey]: formValues,
    redirectPath: createRedirectPath(location),
  };
};
